import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, unref as _unref, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "space-y-8 divide-y divide-gray-200 px-4 py-3" };
const _hoisted_2 = { class: "space-y-8 divide-y divide-gray-200 sm:space-y-5" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Reject ATR\n          "),
    /*#__PURE__*/ _createTextVNode(),
    /*#__PURE__*/ _createElementVNode("p", { class: "mt-1 max-w-2xl text-sm text-red-500" }, "\n            The offer and contract have been rejected, the Hiring Manager and\n            Approvers will be notifed. Please complete the information below and\n            then select Reject.\n          ")
], -1);
const _hoisted_4 = { class: "mt-6 sm:mt-5 space-y-6 sm:space-y-5" };
const _hoisted_5 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", {
    for: "country",
    class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, "\n              Reason for rejection *\n            ", -1);
const _hoisted_7 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_8 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_9 = { class: "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "Comments", -1);
const _hoisted_11 = { class: "mt-1 sm:mt-0 sm:col-span-2" };
const _hoisted_12 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-2 text-sm text-red-500" }, "\n                * Please include any relevant comments, as these will be emailed\n                to the Hiring Manager and Approvers\n              ", -1);
const _hoisted_14 = {
    key: 0,
    class: "pt-5"
};
const _hoisted_15 = { class: "flex justify-end" };
const _hoisted_16 = ["disabled"];
import useVuelidate from '@vuelidate/core';
import { helpers, required, requiredIf } from '@vuelidate/validators';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'reject-form',
    props: {
        atr: {}
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const store = useStore();
        const reason = ref('');
        const comments = ref('');
        const handleRejectAtr = async () => {
            try {
                const payload = {
                    docOwner: props.atr.requestedBy,
                    id: props.atr.docId,
                    state: props.atr.currentStageName,
                    reason: reason.value,
                    comment: comments.value,
                };
                store.dispatch('setIsLoading', true);
                await httpClient.post('/bff/reject-request', payload);
                router.push('/');
                store.dispatch('setIsLoading', false);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'success',
                    title: 'Success!',
                    message: 'The request was rejected',
                });
            }
            catch {
                store.dispatch('setIsLoading', false);
                store.dispatch('setNotificationAll', {
                    visible: true,
                    type: 'error',
                    title: 'Error!',
                    message: 'Could not process your request at this time',
                });
            }
        };
        const handleCancel = () => {
            router.go(-1);
        };
        const rules = computed(() => ({
            reason: { required },
            comments: {
                requiredIf: helpers.withMessage('If other, please specify', requiredIf(reason.value === 'Other (Please specify)')),
            },
        }));
        const v$ = useVuelidate(rules, {
            reason,
            comments,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("form", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _hoisted_3,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _hoisted_6,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_7, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "employee-name-input",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((reason).value = $event)),
                                        type: "text",
                                        name: "employeeName",
                                        autocomplete: "name",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                        onChange: _cache[1] || (_cache[1] = ($event) => (_unref(v$).$validate())),
                                        onInput: _cache[2] || (_cache[2] = ($event) => (_unref(v$).reason.$touch()))
                                    }, null, 544), [
                                        [_vModelText, reason.value]
                                    ]),
                                    _createTextVNode(),
                                    (_unref(v$).reason.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "\n                * " + _toDisplayString(_unref(v$).reason.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_11, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        id: "about",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((comments).value = $event)),
                                        name: "about",
                                        rows: "3",
                                        class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md",
                                        onBlur: _cache[4] || (_cache[4] = ($event) => (_unref(v$).comments.$touch()))
                                    }, null, 544), [
                                        [_vModelText, comments.value]
                                    ]),
                                    _createTextVNode(),
                                    (_unref(v$).comments.$error && _unref(v$).comments.$dirty)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "\n                * " + _toDisplayString(_unref(v$).comments.$errors[0].$message), 1))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    _hoisted_13
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.atr.currentStageName === 'starter.notifyBudgetApprover' || _ctx.atr.currentStageName === 'starter.notifyHROps')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                                    onClick: _withModifiers(handleCancel, ["prevent"])
                                }, "\n            Cancel\n          "),
                                _createTextVNode(),
                                _createElementVNode("button", {
                                    disabled: !_unref(v$).$dirty || _unref(v$).$error,
                                    type: "submit",
                                    class: "ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200 disabled:text-gray:500 disabled:cursor-not-allowed",
                                    onClick: _withModifiers(handleRejectAtr, ["prevent"])
                                }, "\n            Save\n          ", 8, _hoisted_16)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
